import type { SubSegment } from "@teksta/shared-types";

export const segmentsBinarySearch = ({
  segments,
  timestampS,
}: {
  segments: SubSegment[];
  timestampS: number;
}) => {
  let start = 0;
  let end = segments.length - 1;
  let middle = Math.floor((start + end) / 2);

  while (start <= end) {
    const middleSegment = segments[middle];
    const middleSegmentStart = middleSegment.start;
    const middleSegmentEnd = middleSegment.end;
    if (middleSegmentStart <= timestampS && middleSegmentEnd >= timestampS) {
      return middle;
    } else if (middleSegmentStart > timestampS) {
      end = middle - 1;
    } else if (middleSegmentEnd < timestampS) {
      start = middle + 1;
    }
    middle = Math.floor((start + end) / 2);
  }
  return -1;
};
